import type { NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import _ from 'lodash';
import { getStaticPropsNicho } from 'ui';
import { Brand, Cooches } from '../../data/schema';
import { readItems } from '@directus/sdk';
import { cdn, db } from 'data';

type Props = {
	brands: Brand[];
};

const Brands: NextPage<Props> = ({ brands }) => {
	const createCard = (brand: Brand) => {
		return (
			<Link
				href={`/marcas-de-coches/${brand.id}`}
				key={`brand-card-${brand.id}`}
				className="shadow-lg rounded-2xl w-64 m-4 p-4 py-6 bg-white">
				<div className="flex flex-col items-center justify-center">
					<div className="w-24 h-24 rounded-full flex p-1">
						<Image
							src={cdn(brand.logo)}
							className="object-contain"
							alt={`Cooches - Marcas de coches - Logo de ${brand.name}`}
							title={`Cooches - Marcas de coches - Logo de ${brand.name}`}
							width={88}
							height={88}
							layout="fixed"
						/>
					</div>
					<h2 className="text-gray-800 text-xl font-medium mb-4 mt-4">{brand.name}</h2>
					<h3 className="text-gray-400 text-center text-xs px-2">{brand.shortDescription}</h3>
				</div>
			</Link>
		);
	};

	return (
		<div className="container">
			<div>
				<h1 className="text-3xl dark:text-gray-200">
					Todas las marcas de coches, antiguas y modernas.
				</h1>
				<h2 className="text-xl	dark:text-gray-200">
					A continuación te mostramos todas las marcas de coches que han existido alguna vez y las
					marcas de coches actuales.
				</h2>
			</div>
			<div className="flex flex-wrap justify-center">
				{brands.map((brand: Brand) => {
					return createCard(brand);
				})}
			</div>
		</div>
	);
};

export const getStaticProps = getStaticPropsNicho(async () => {
	const cms = db<Cooches>();
	const brands = await cms.request(readItems('co_brands', { sort: 'name' }));

	return {
		props: {
			brands,
			title: 'Marcas de coches'
		}
	};
});

export default Brands;
